export function formatTaskDeadline(
  canonicalIso: string,
  timeZone: string,
  locale = 'vi-VN',
): string {
  const deadline = new Date(canonicalIso)
  if (Number.isNaN(deadline.getTime())) return canonicalIso

  try {
    return new Intl.DateTimeFormat(locale, {
      dateStyle: 'medium',
      timeStyle: 'short',
      timeZone,
    }).format(deadline)
  } catch {
    return new Intl.DateTimeFormat(locale, {
      dateStyle: 'medium',
      timeStyle: 'short',
      timeZone: 'UTC',
    }).format(deadline)
  }
}
